import React, { useEffect, useState } from 'react'
import {  useTranslation } from 'react-i18next';

import {MwInputText,MwSelector} from '../../ui';
import { useCurrent } from '../../../hooks';
import { LuBanknote } from 'react-icons/lu';

const InvFormHeader = ({
    invNo,
    setInvNo,
    invRef,
    invDate,
    invDateDue,
    invCurrency,
    customers,
    onClickNewCustomer,
    salesmans,
    onClickNewSalesman,
    customerSelected,
    setCustomerSelected,
    salesmanSelected,
    setSalesmanSelected,
    formErrors,
    SETTING_INVOICE,
    selectedCurrency,
    setSelectedCurrency,
    currencySymbol,
    currencies,
    setCurrencies,

    }) => {
        const [t,i18next] = useTranslation('global')
                const lang= i18next.dir() === 'rtl' ? 'ar' : 'en';
                        const [showCurrencySelector, setShowCurrencySelector] = useState(false);
const formatCurrenciesForSelector = () => {
    if (!currencies || currencies.length === 0) {
        return [];
    }
    
    return currencies.map(currency => ({
        label: ` ${lang === 'ar' ? currency.name_ar || currency.name_en : currency.name_en || currency.name_ar}`,
        value: currency.id,
        ...currency
    }));
  };      

        const date = new Date();
        const today = date.toLocaleDateString('en-CA'); // Get current date in the format 'YYYY-MM-DD'
        const todayAndTime = date.toLocaleDateString('en-CA')
        // +' '+date.toLocaleTimeString('it-IT'); // Get current date in the format 'YYYY-MM-DD'
        // invDate.current.value = todayAndTime;
        // invDateDue.current.value = today


               
    return (
            <div className="flex flex-col   text-[#251658]  md:flex-row justify-between  items-center gap-2 my-2 mb-3">
                <div className="flex w-full md:w-fit gap-2 " >
                    <div className="flex-1 md:w-24   ">
                        <MwInputText 
                            label={t('invoice.invoiceNo')}
                            id='inv_no' 
                            value={invNo} 
                            disabled={false} 
                            onChange={(e)=>setInvNo(e.target.value)} />
                    </div>
                    <div className="flex-1 md:w-20">
                        <MwInputText 
                            label={t('invoice.invoiceRef')}
                            inputRef={invRef}
                            id='inv_ref' 
                            defaultValue=''
                            />
                    </div>
                </div>
                    <div className="flex w-full md:w-fit gap-2" >
                    <div className="flex-1 md:w-38 ">
                        <MwInputText 
                            label={t('invoice.invoiceDate')}
                            inputType='date'
                            inputRef={invDate} 
                            id='inv_date'
                            defaultValue={todayAndTime}
                            invalid = {!!formErrors?.invDate}
                            // invalidMsg={formErrors?.invDate}
                            />
                    </div>
                    <div className="flex-1 md:w-28">
                        <MwInputText 
                            label={t('invoice.invoiceDateDue')}
                            inputType='date'
                            inputRef={invDateDue} 
                            id='inv_date_due'
                            defaultValue={today}
                            invalid = {!!formErrors?.invDateDue}
                            />
                    </div>
                </div>
                <div className="relative flex-1  flex w-full ">
                    <div className="flex-1 flex  flex-col ">
                        <MwSelector 
                            label={t('quotes.Select Supplier')}
                            _data={customers} 
                            dataType='customer' 
                            onClickNew = {onClickNewCustomer}
                            selectedItem = {customerSelected}
                            setSelectedItem = {setCustomerSelected}
                            selectFirstValue = {SETTING_INVOICE?.INV_CUSTOMER_DEFAULT}
                            />
                    </div>

                        <div className="w-36  relative">
                      {!showCurrencySelector && !selectedCurrency?.length ? (
                        <button 
                          onClick={() => setShowCurrencySelector(true)}
                          className="w-full !ms-2 h-full mt-6 max-h-[30px] flex items-center justify-center gap-2 p-2 border border-gray-300 rounded-md hover:bg-blue-50 text-[#251658] text-xs transition-all duration-300"
                        >
                          <svg className="w-4 h-4 animate-bounce" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                    <LuBanknote/>
                          </svg>
                          <span className='font-bold '>{currencySymbol}</span>
                        </button>
                      ) : (
                        <MwSelector
                          label={lang === 'ar' ? "العملة" : "Main"}
                          _data={formatCurrenciesForSelector()}
                          dataType="labelValue"
                          setSelectedItem={(value) => {
                            setSelectedCurrency(value);
                          }}
                          selectedItem={selectedCurrency}
                          initalValue={lang === 'ar' ? "اختر العملة" : "Select Currency"}
                          withSearch={false}
                          withLabel={false}
                          withAddNew={false}
                          className={"ms-2"}
                        />
                      )}
                    </div>
                    {/* <div className="flex-1 flex flex-col ">
                        <MwSelector
                        label={t('invoice.selectSalesman')}
                        _data={salesmans} 
                        dataType='salesman' 
                        onClickNew={onClickNewSalesman}
                        selectedItem = {salesmanSelected}
                        setSelectedItem = {setSalesmanSelected}
                        selectFirstValue = {SETTING_INVOICE.INV_SALESMAN_DEFAULT}
                        />
                    </div> */}
                </div>
            </div>
        
    )
}

export default InvFormHeader